export function checkIfConfigExists(
  currentConfigList: string[] | undefined,
  config: string
) {
  return currentConfigList?.find(currentConfig => currentConfig === config);
}
